/**
 * Vault footer scripts — runs after jQuery/jQuery UI from footer.
 * Uses global $ (no import) so this bundle does not include jQuery.
 * Reduces inline script usage for CSP (hash/nonce) compliance.
 */
(function () {
    'use strict';
    if (typeof window.$ === 'undefined') {
        return;
    }
    var $ = window.$;

    $(window).on('load', function () {
        // Show review by default (PDP)
        $('#productReviews-content').addClass('is-open');
        $('#product-reviews .toggleLink').addClass('is-open');
    });

    $(window).on('load', function () {
        $(function () {
            $('header li.navUser-item.currency-menu a.navUser-action.has-dropdown').on('click', function (e) {
                e.preventDefault();
            });
        });
    });

    // Back to top button
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 100) {
            $('.backtoTop').addClass('visible');
        } else {
            $('.backtoTop').removeClass('visible');
        }
    });
    $('.backtoTop').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 600);
        return false;
    });
})();
